import { createPopper } from '@popperjs/core';

export default class Menu {

	constructor(element) {
		this.element = element;
		this.itemsWithChildren = (this.element instanceof HTMLElement) ? this.element.querySelectorAll('.menu-item-has-children') : undefined;
		this.isAlignEnd = (this.element instanceof HTMLElement) ? this.element.classList.contains('menu--align-end') : false;
	}

	init() {
		this.initItemsWithChildren();
	}

	initItemsWithChildren() {
		if (this.itemsWithChildren) {
			this.itemsWithChildren.forEach(item => {
				this.initItemSubmenu(item);
			});
		}
	}

	initItemSubmenu(item) {
		const submenu = item.querySelector( '.sub-menu');
		submenu.setAttribute('data-menu-item-id', item.id);
		const arrow = this.appendArrow(submenu);
		const instance = createPopper(item, submenu, {
			placement: this.getPlacement(item),
			strategy: 'fixed',
			modifiers: [
				{
					name: 'preventOverflow',
					options: {
						mainAxis: true,
						altAxis: true,
					},
				},
				{
					name: 'arrow',
					options: {
						element: arrow,
					},
				},
			],
		});
		submenu.gigsPopperInstance = instance;
	}

	getPlacement(item) {
		let placement = 'auto';
		if (item instanceof HTMLElement) {
			if (item.parentElement.classList.contains('menu')) {
				placement = this.isAlignEnd ? 'bottom-end' : 'bottom-start';
			} else {
				placement = this.isAlignEnd ? 'left-start' : 'right-start';
			}
		}
		return placement;
	}

	appendArrow(submenu) {
		const arrow = document.createElement('i');
		arrow.setAttribute('data-popper-arrow', true);
		submenu.appendChild(arrow);
		return arrow;
	}
}

